  export default function (data) {
    return {
      props: {
        value: {
          type: Object,
          default: () => (data),
          required: true
        },
      },
      data() {
        return {
          ...data
        }
      },
      watch: {
        value: {
          deep: true,
          immediate: true,
          handler(newValue) {
            _.forEach(newValue, (value, name) => {
              this[name] = value
            })
          }
        }
      },
      created() {
        _.forEach(data, (value, key) => {
          this.$watch(key, this.emitObjectUpdate)
        })
      },
      methods: {
        emitObjectUpdate() {
          var newValue = {}
          _.forEach(data, (value, key) => {
            newValue[key] = this[key]
          })

          this.$emit('input', newValue)
        }
      }
    }
  }